/**
 * Formats a number of seconds as "Xm Ys" (minutes and seconds).
 * @param totalSeconds - Total number of seconds (e.g. from countdown timer)
 * @returns Formatted string, e.g. "1m 30s", "0m 45s"
 */
export function formatSecondsToMinutesSeconds(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));

  if (seconds < 60) return `${ seconds }s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${ minutes }m ${ remainingSeconds }s`;
}
